<div class="flex items-center w-full uppercase">
    <span class="grow-0 pe-4">{{(calculateDateDiff(spettacolo?.dal, spettacolo?.al) <= 0) ? (spettacolo?.al | date: 'EEE' | uppercase) : (spettacolo?.dal | date: 'dd MMM yy' ) }}</span>
    <div class="rounded h-[2px] grow date-line min-w-4" [ngClass]="{'bg-dark': colore == 'dark', 'bg-light': colore == 'light'}"></div>
    <span class="grow-0 ps-4">{{spettacolo?.al | date: 'dd MMM yy' | uppercase}}</span>
</div>